import { Application, ApplicationConfig } from '@bybeam/platform-types';
import { isSectionComplete } from '@platform-ui/application/hooks/useApplicationProgress.js';
import { getApplicantSections } from '@platform-ui/utilities/application/config.js';
import { getSectionRoute } from '@platform-ui/utilities/application/section.js';
import ApplicantRoutes from './ApplicantRoutes.js';

export default function resumeApplication(config: ApplicationConfig, app: Application): string {
  const sections = getApplicantSections(config);
  const firstIncompleteSection = sections.find(
    (section) => !isSectionComplete(section, app.answers ?? {}, app),
  );
  return firstIncompleteSection
    ? getSectionRoute(firstIncompleteSection, app.answers)
    : ApplicantRoutes.APPLICATION_REVIEW;
}
